import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'トップ' },
    { path: '/about', label: '当店について' },
    { path: '/services', label: 'サービス・料金案内' },
    { path: '/company', label: '会社概要' },
    { path: '/contact', label: '予約・お問い合わせ' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${
          isScrolled ? 'shadow-md' : ''
        }`}
      >
        <div className="w-full px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0">
              <span className="text-base lg:text-lg font-medium whitespace-nowrap transition-colors text-gray-dark">
                おかやま脱毛サロン・エステ株式会社
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-light whitespace-nowrap transition-colors hover:text-gray-medium text-gray-dark ${location.pathname === link.path ? 'font-medium' : ''}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* Desktop CTA */}
            <div className="hidden lg:flex items-center space-x-4">
              <a
                href="tel:086-012-3456"
                className="text-sm font-light whitespace-nowrap transition-colors text-gray-dark"
              >
                <i className="ri-phone-line mr-2"></i>
                086-012-3456
              </a>
              <Link
                to="/contact"
                className="px-6 py-2.5 bg-gray-dark text-white text-sm font-light rounded-full whitespace-nowrap hover:bg-gray-medium transition-colors cursor-pointer"
              >
                お問い合わせ
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
              aria-label="メニュー"
            >
              <i className={`text-2xl transition-colors text-gray-dark ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 bg-white transform transition-transform duration-300 lg:hidden ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        style={{ top: '80px' }}
      >
        <div className="flex flex-col p-6 space-y-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-lg font-light text-gray-dark hover:text-gray-medium transition-colors ${
                location.pathname === link.path ? 'font-medium' : ''
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="pt-6 border-t border-gray-light space-y-4">
            <a
              href="tel:086-012-3456"
              className="flex items-center text-lg font-light text-gray-dark"
            >
              <i className="ri-phone-line mr-3 w-6 h-6 flex items-center justify-center"></i>
              086-012-3456
            </a>
            <Link
              to="/contact"
              className="block w-full px-6 py-3 bg-gray-dark text-white text-center text-base font-light rounded-full whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
